// Import model
import { DataviewOtgWoodCatalogStyleResponse } from '../models/DataviewOtgWoodCatalogStyleResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgWoodCatalogStyleRequest } from '../models/FilterOtgWoodCatalogStyleRequest';
import { OtgWoodCatalogStyle } from '../models/OtgWoodCatalogStyle';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgWoodCatalogStyleRequestSerializer } from './FilterOtgWoodCatalogStyleRequestSerializer';
import { OtgWoodCatalogStyleSerializer } from './OtgWoodCatalogStyleSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgWoodCatalogStyleResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgWoodCatalogStyleResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgWoodCatalogStyleResponse instance
   */
  static deserialize(json: string): DataviewOtgWoodCatalogStyleResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgWoodCatalogStyleResponse instance
   */
  static fromObject(obj: any): DataviewOtgWoodCatalogStyleResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgWoodCatalogStyleResponse');
    }


    const instance: DataviewOtgWoodCatalogStyleResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgWoodCatalogStyleSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgWoodCatalogStyleRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgWoodCatalogStyleResponse instances
   */
  static deserializeArray(json: string): DataviewOtgWoodCatalogStyleResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgWoodCatalogStyleResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgWoodCatalogStyleResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgWoodCatalogStyleResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgWoodCatalogStyleResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgWoodCatalogStyleSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgWoodCatalogStyleRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgWoodCatalogStyleResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgWoodCatalogStyleResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
